export default {
  noActiveRecipe: 'Kein aktives Rezept an diesem Ofen.',
  confirmSave: {
    header: 'Sollwerte speichern?',
    message: 'Die Sollwerte werden an den Ofen übertragen, und seine aktuellen Sollwerte werden auf diese Werte zurückgesetzt.',
  },
};
